import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  hiring: {},
  strength: '',
  project: '',
  timeing: '',
  details: {},
}

export const Slice = createSlice({
  name: 'reducerApp',
  initialState,
  reducers: {
    hire: (state, action) => {
      state.hiring = action.payload
    },
    str: (state, action) => {
      state.strength = action.payload
    },
    pro: (state, action) => {
      state.project = action.payload
    },
    time: (state, action) => {
      state.timeing = action.payload
    },
    userDetails: (state, action) => {
      state.details = action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const { hire, str, pro ,time,userDetails} = Slice.actions

export default Slice.reducer